import { z } from 'zod';

export enum RefIdentityProviderTypeEnum {
  OIDC = 1,
  UsernamePassword = 2,
  VeevaIConnect = 3,
  M2MSession = 4,
  TrinityEdge = 5,
  Sentiment = 6,
  Salesforce = 7,
}
export const refIdentityProviderTypeSchema = z.enum(RefIdentityProviderTypeEnum);
export type RefIdentityProviderType = z.infer<typeof refIdentityProviderTypeSchema>;

export const getIdentityProviderTypeName = (typeId: RefIdentityProviderType) => {
  return {
    [RefIdentityProviderTypeEnum.OIDC]: 'OIDC',
    [RefIdentityProviderTypeEnum.UsernamePassword]: 'Username Password',
    [RefIdentityProviderTypeEnum.VeevaIConnect]: 'Veeva IConnect',
    [RefIdentityProviderTypeEnum.M2MSession]: 'M2M Session',
    [RefIdentityProviderTypeEnum.TrinityEdge]: 'Trinity Edge',
    [RefIdentityProviderTypeEnum.Sentiment]: 'Sentiment',
    [RefIdentityProviderTypeEnum.Salesforce]: 'Salesforce',
  }[typeId] ?? 'Unknown';
};